// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Banner_navbar__1Hlaw","inactive":"Banner_inactive__31YDr","active":"Banner_active__1nbKA"};